import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, Share2, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useAuth } from "@/context/AuthContext";
import { ShareConversationDialog } from "./ShareConversationDialog";
import { SharedConversationDisplay } from "./SharedConversationDisplay";

interface HeaderProps {
  onMenuClick?: () => void;
  conversationId?: string | null;
  conversationTitle?: string;
  conversationOwnerId?: string;
}

const Header = ({ 
  onMenuClick, 
  conversationId, 
  conversationTitle,
  conversationOwnerId 
}: HeaderProps) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [shareDialogOpen, setShareDialogOpen] = useState(false);

  const isSharedConversation = user && conversationOwnerId && user.id !== conversationOwnerId;
  const canShare = user && conversationOwnerId && user.id === conversationOwnerId;

  return (
    <>
      <header className="border-b p-3 md:p-4 flex items-center gap-3 flex-shrink-0">
        {/* Botão Menu (só mobile) */}
        {onMenuClick && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onMenuClick}
            className="md:hidden flex-shrink-0"
            aria-label="Abrir menu"
          >
            <Menu className="h-5 w-5" />
          </Button>
        )}
        
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h1 className="text-base md:text-lg font-semibold truncate">
              {conversationTitle || "Chat"}
            </h1>
            {isSharedConversation && (
              <Badge variant="secondary" className="gap-1 text-xs">
                <Users className="w-3 h-3" />
                Compartilhado
              </Badge>
            )}
          </div>
        </div>

        {/* BOTÕES À DIREITA */}
        <div className="flex items-center gap-2">
          {/* Compartilhar */}
          {conversationId && canShare && (
            <>
              <SharedConversationDisplay 
                conversationId={conversationId} 
                maxVisible={3} 
              />
              <Button
                variant="outline"
                size="sm"
                onClick={() => setShareDialogOpen(true)}
                className="gap-1"
              >
                <Share2 className="h-4 w-4" />
                <span className="hidden sm:inline">Compartilhar</span>
              </Button>
            </>
          )}

        </div>
      </header>

      {/* Dialog de Compartilhamento */}
      {conversationId && conversationTitle && (
        <ShareConversationDialog
          open={shareDialogOpen}
          onOpenChange={setShareDialogOpen}
          conversationId={conversationId}
          conversationTitle={conversationTitle}
        />
      )}
    </>
  );
};

export default Header;
